import { Grid } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  root: {
    paddingTop: theme.spacing(4.5),
    paddingBottom: theme.spacing(3)
  },
  grid: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(2)
    }
  },
  flexflowStatisticsWrapper: {
    marginTop: theme.spacing(2)
  }
}));

export const ColumnContentWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  width: '100%'
}));
